export default "__VITE_ASSET__5e93462d__"